module.exports = __webpack_public_path__ + "img/Imagotipo.6ec8dc45.png";